module.exports = __webpack_public_path__ + "media/2022/content-experts-7f5a54a2.png";